module.exports = __webpack_public_path__ + "static/media/line_chart_icon.8f1d6486.svg";